import { ExpeditionActionsAttendance } from "./attendance";
import { ExpeditionsActionsEnable } from "./enable";

export const ExpeditionsActions = {
  enable: ExpeditionsActionsEnable,
  attendance: ExpeditionActionsAttendance
};
